/**
 * Enum for Main market types (Moneyline, Handicap, Over/Under)
 * @readonly
 * @enum {number}
 */
export var MainMarketsTypes;
(function (MainMarketsTypes) {
    MainMarketsTypes[MainMarketsTypes["ML"] = 1] = "ML";
    MainMarketsTypes[MainMarketsTypes["HC"] = 2] = "HC";
    MainMarketsTypes[MainMarketsTypes["OU"] = 3] = "OU";
})(MainMarketsTypes || (MainMarketsTypes = {}));
/**
 * Get market type id in FullBetSlip format
 * @param {Market} market Market to process
 * @return {string} Market type id
 */
export const getMarketTypeId = (market) => {
    let marketTypeId = market.marketType && market.marketType.id || "";
    if (marketTypeId.startsWith(`${MainMarketsTypes.ML.toString()}_`)
        || marketTypeId.startsWith(`${MainMarketsTypes.HC.toString()}_`)
        || marketTypeId.startsWith(`${MainMarketsTypes.OU.toString()}_`)) {
        return marketTypeId.substring(2, marketTypeId.length);
    }
    return marketTypeId;
};
//# sourceMappingURL=getMarketTypeId.js.map